import { useRef, useEffect } from "react";

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export default usePrevious;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chakra-ui/core/dist/es/usePrevious/index.js
// module id = 107
// module chunks = 0